import { getNumberInitials } from '@/utils/getNumberInitials';
import Avatar from '@mui/material/Avatar';

type InitialAvatarProp = {
    name?: string | null;
    initialsCount?: number;
    width?: number;
    height?: number;
};

const UserInitialsAvatar: React.FC<InitialAvatarProp> = ({
    name,
    width,
    height,
    initialsCount = 2,
}) => {
    return (
        <Avatar sx={{ width, height }}>
            {getNumberInitials(name ?? '', initialsCount)}
        </Avatar>
    );
};

export default UserInitialsAvatar;
